import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import useFetchData from '../../../../../../../../hooks/useFetchData'
import { useDispatch, useSelector } from 'react-redux'
import { updateFilter, showFilter } from '../../../../../../../../store/actions/filter.actions'
import { useLocation, useNavigate } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import InputField from '../../../../../../../FormControl/input/InputField'
import SelectMultipleField from '../../../../../../../FormControl/input/SelectMultipleField'
import { updateSkip } from '../../../../../../../../store/actions/datatable.actions'
import DialogConfirmCancel from '../../../../../../../dialog/DialogConfirm'

const FilterDialog = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const date = useSelector(state => state?.date?.date || new Date())
  const filter = useSelector(state => state?.filter.usersClass?.filter || {})
  const open = useSelector(state => state?.filter.usersClass?.open || false)

  const { isLoading: isLoadingYears, data: dataYears, error: errorFetchYears } = useFetchData('setting/year')

  const dispatch = useDispatch()

  const [form, setInputForm] = useState(filter)
  const [error, setInputError] = useState({ })

  useEffect(() => {
    if (!isEmpty(filter)) {
      setInputForm(filter)
    }
  }, [filter])

  const onClose = () => {
    dispatch(showFilter('usersClass', false))
  }

  const onChange = (name, value) => {
    if (name === 'yearLevelId') {
      setInputError({ ...error, [name]: null, yearLevel: null })
      const yearLevel = dataYears.filter((item) => value.includes(item._id))
      setInputForm({ ...form, [name]: value, yearLevel })
    } else {
      setInputForm({ ...form, [name]: value })
      setInputError({ ...error, [name]: null })
    }
  }

  const onApply = () => {
    onClose()
    const filter = {
      ...form
    }

    dispatch(updateFilter('usersClass', filter));
    dispatch(updateSkip('usersClass', 0));
    navigate(pathname, { state: filter });
  }

  return (
    <DialogConfirmCancel
      id='dialog-filter-users-class-student-selector'
      open={open} 
      title="Filter"
      maxWidth='xs'
      onCancel={onClose}
      onConfirm={onApply}
      textConfirm='Apply'
    >
      <Box className='flex flex-col gap-4'>
        <div className='grid grid-cols-3 items-center gap-4'>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            Code
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-code'
              name="code"         
              value={form.code}  
              error={error.code}
              helperText={error.code}                          
              maxDate={date}
              onChange={(e) => onChange("code", e.target.value)}       
            />     
          </div>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            first name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-first-name'
              name="firstName"         
              value={form.firstName}  
              error={error.firstName}
              helperText={error.firstName}                          
              maxDate={date}
              onChange={(e) => onChange("firstName", e.target.value)}       
            />     
          </div>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            last name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-last-name'
              name="lastName"         
              value={form.lastName}  
              error={error.lastName}
              helperText={error.lastName}                          
              maxDate={date}
              onChange={(e) => onChange("lastName", e.target.value)}       
            />     
          </div>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            preferred name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-preferred-name'
              name="preferredName"         
              value={form.preferredName}  
              error={error.preferredName}
              helperText={error.preferredName}                          
              onChange={(e) => onChange("preferredName", e.target.value)}       
            />     
          </div>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            year level
          </Typography>
          <div className='col-span-2'>
            <SelectMultipleField 
              id='form-filter-year-level'
              name="yearLevelId"
              value={form.yearLevelId}
              error={error.yearLevelId || errorFetchYears}
              helperText={error.yearLevelId || errorFetchYears}                          
              onChange={(e) => onChange("yearLevelId", e.target.value)}
              loading={isLoadingYears}
              options={dataYears?.map(item => ({ value: item._id, label: item.name })) || []}
              placeholder="Choose a year level"
            />
          </div>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            form
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-form'
              name="form"         
              value={form.form}  
              error={error.form}
              helperText={error.form}                          
              maxDate={date}
              onChange={(e) => onChange("form", e.target.value)}       
            />     
          </div>
          <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
            house
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-house'
              name="house"         
              value={form.house}  
              error={error.house}
              helperText={error.house}                          
              maxDate={date}
              onChange={(e) => onChange("house", e.target.value)}       
            />     
          </div>
        </div>
      </Box>
    </DialogConfirmCancel>
  )
}

export default FilterDialog

